module.exports = __webpack_public_path__ + "frontend/img/icon_arrow_left.d42c3e10.svg";